import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

import MDTypography from "@/components/atoms/MDTypography";
import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import IContact from "@/interfaces/contact.interface";
import { ContactInfoMessages } from "@/messages/contacts/contact-Info.messages";

import { AddressTableRow } from "./row";
import { ADDRESSES_TABLE_COLUMNS } from "../../constants";

interface Props {
  contact: IContact | null;
  messages: ContactInfoMessages;
}

export function AdditionalAddressesTable({ contact, messages }: Props) {
  const columns = ADDRESSES_TABLE_COLUMNS(messages);
  const HEADER_CELL_WIDTH = `${100 / columns.length}%`;

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableHeaderRow>
            {columns.map((label, index) => (
              <HeaderTableCell key={`${index} - ${label}`} width={HEADER_CELL_WIDTH}>
                {label}
              </HeaderTableCell>
            ))}
          </TableHeaderRow>
        </TableHead>

        <TableBody>
          {contact?.addresses && contact.addresses.length <= 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                <MDTypography variant="h6" color="text" fontWeight={"regular"}>
                  {messages.noAdditionalAddressesMessage}
                </MDTypography>
              </TableCell>
            </TableRow>
          ) : (
            contact?.addresses &&
            contact.addresses.map((item, index) => (
              <AddressTableRow
                key={`${index} - ${item.id}`}
                address={item}
                index={index}
                messages={messages}
                contact={contact}
              />
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
